import { Liquidations } from "@/shared/types/chart-risk";

export enum Param {
  ShortCumulativeAmount = "shortCumulativeAmount",
  LongCumulativeAmount = "longCumulativeAmount",
  ShortAmount = "shortAmount",
  LongAmount = "longAmount",
}

export type LiquidationsDisplay = Liquidations & {
  shortAmount?: number;
  longAmount?: number;
  shortCumulativeAmount?: number;
  longCumulativeAmount?: number;
  isCenterPoint: boolean;
};
